// extracted by mini-css-extract-plugin
export default {"grid":"DebugInfoDialog_grid__2z4d0","name":"DebugInfoDialog_name__2mvbF","value":"DebugInfoDialog_value__mePhz","demoModeButton":"DebugInfoDialog_demoModeButton__7k19S"};